<template>
  <div class="column full-height">
    <header
      class="row items-center justify-between q-px-2x-md full-width no-wrap"
      :style="{ height: '76px' }"
    >
      <span
        class="text-lg text-neutral text-weight-medium"
        :style="{ maxWidth: '75%' }"
      >
        {{ formHeading }}
      </span>
      <div>
        <PBadge
          :label="badgeLabel"
          class="text-sm text-weight-medium q-ma-xxs"
          color="neutral-30"
          text-color="neutral-80"
          rounded
        />
        <PBtn color="primary" flat round @click="onClose">
          <CloseIcon class="icon" />
        </PBtn>
      </div>
    </header>

    <q-separator color="neutral-40" />

    <div class="q-px-2x-md q-py-xl col overflow-auto text-sm">
      <div
        v-if="initialLoading"
        class="flex items-center justify-center full-height"
      >
        <q-spinner color="primary" size="40px" />
      </div>
      <div v-for="log in logTrail" :key="log._id">
        <div class="row q-col-gutter-xs">
          <span class="col-2 text-neutral-80">TimeStamp </span>
          <span class="col-10">{{
            formatDate(log.event_time, "DD MMM YYYY, hh:mm A") || "-"
          }}</span>
          <span class="col-2 text-neutral-80">Details </span>
          <span class="col-10">
            {{ upperFirstFunc(log.description || "") || "-" }}
          </span>
          <span class="col-2 text-neutral-80">Changed By </span>
          <span class="col-10 text-capitalize">
            {{ log.actor.user_name || "-" }}
          </span>
        </div>

        <div class="row justify-end">
          <PBtn flat text @click="viewLogDetails(log)">
            <span>View Changes</span>
          </PBtn>
        </div>

        <q-separator class="q-mb-xl full-width" />
      </div>
      <PLoadingCta
        :loading="loadMoreLoading"
        :has-more="hasMore"
        @load-more="loadMore"
      />
    </div>
  </div>
</template>

<script setup>
import CloseIcon from "assets/icons/close.svg";
import { date } from "quasar";
import { upperFirstFunc } from "src/assets/scripts/utilities/helpers";

const { formatDate } = date;

const { logTrail, entity, actionAreas } = storeToRefs(useAuditLogsStore());
const { toggleAuditLogDetailsDrawer, toggleAuditLogsDrawer } =
  useAuditLogsStore();

const props = defineProps({
  params: { type: Object, default: () => ({}) },
});

const { initialLoading, loadMoreLoading, hasMore, loadMore } =
  useAuditLogsPagination(toRef(props, "params"));

const formHeading = computed(() => {
  return (
    "Audit Trail: " +
    (unref(initialLoading)
      ? "Loading..."
      : unref(entity)?.shop_name ||
        unref(entity)?.trade_name ||
        unref(entity)?.name ||
        unref(entity)?.number ||
        unref(entity)?.invc_number ||
        unref(entity)?.bill_number ||
        unref(entity)?.internal_number ||
        unref(entity)?.po_info?.internal_number ||
        unref(entity)?.bank_name ||
        (unref(badgeLabel) == "Audit Logs" && unref(badgeLabel)) ||
        "-")
  );
});

const badgeLabel = computed(() => {
  const entity = unref(logTrail)?.[0]?.entity;

  const lastEntityCode = Array.isArray(entity)
    ? entity[entity.length - 1]
    : entity;

  const matchedActionArea = unref(actionAreas).find(
    (area) => area.code === lastEntityCode,
  );

  return matchedActionArea ? matchedActionArea.name : lastEntityCode;
});

const onClose = () => {
  toggleAuditLogsDrawer({
    open: false,
  });
};

const viewLogDetails = (log) => {
  toggleAuditLogDetailsDrawer({
    open: true,
    level: 0,
    props: {
      log,
    },
  });
};
</script>
